import { Api } from 'vl-common/src/api';

export const postEligibilityPolicy = (params: { caseId: number; policyCode: string; applied: boolean }) => {
  const { caseId, policyCode, applied } = params;
  return () => Api.referrers.postEligibilityPolicy(caseId, policyCode, applied).then(({ data }) => data);
};

export default postEligibilityPolicy;
